import { httpsCallable } from 'firebase/functions';
import { ensureAppCheckReady, functions } from '../firebase';
import type { Locale, PlannerDraftStop, PlannerDraftV1, PlannerInterest, PlannerPace, TripPlace } from '../types';

export async function previewPlaceSearch(query: string, locale: Locale) {
  await ensureAppCheckReady();
  const call = httpsCallable<{ query: string; locale: Locale }, { places: TripPlace[] }>(functions, 'previewPlaceSearch');
  return (await call({ query, locale })).data.places;
}

export async function previewDayPlan(input: {
  destination: TripPlace;
  date: string;
  locale: Locale;
  timeWindow: { start: string; end: string };
  pace: PlannerPace;
  interests: PlannerInterest[];
  excludedPlaceIds?: string[];
}) {
  await ensureAppCheckReady();
  const call = httpsCallable<typeof input, {
    title: string;
    stops: PlannerDraftStop[];
    alternatives: PlannerDraftStop[];
    legs: PlannerDraftV1['legs'];
    distanceKm?: number;
    durationMinutes?: number;
    notice: string;
  }>(functions, 'previewDayPlan');
  return (await call(input)).data;
}

export async function claimPlannerDraft(draft: PlannerDraftV1) {
  await ensureAppCheckReady();
  const call = httpsCallable<{ draft: PlannerDraftV1 }, { tripId: string }>(functions, 'claimPlannerDraft');
  return (await call({ draft })).data;
}
